import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Lookup } from '../../lookup/lookup.model';
import { LookupService } from '../../lookup/lookup.service';
import { SharedService } from '../../shared.service';
import { Enrollment } from '../../student/enrollment.model';
import { UserService } from '../../user/user.service';
import { User } from '../../user/user.model';
import { TylerMatTableDataSource } from '../../angular-material/extended.class';
import { StudentService } from '../../student/student.service';
import { YearService } from '../../year/year.service';
import { Student } from '../../student/student.model';
import { ErrorList } from '../../controls/error-prompt/error-list.model';
import { OnlineRegistrationService } from '../../../student360/online-registration/online-registration.service';
import { Year } from '../../year/year.model';

@Component({
  selector: 'app-re-enroll-students',
  templateUrl: './re-enroll-students.component.html',
  styleUrls: ['./re-enroll-students.component.css']
})
export class ReEnrollStudentsComponent implements OnInit {

  yearId: number;
  familyId: number;
  selectedYear: Year;
  columnToDisplay: string[] = ['Checked', 'Student', 'GradeLevel', 'Previous Enrollment'];
  // columnToDisplay: string[] = ['Student', 'GradeLevel'];
  gradeLevels: Lookup[];
  students: Enrollment[];
  currentUser: User;
  angularMatDataStudents = new TylerMatTableDataSource();
  allStudentsSelected = false;
  errors: ErrorList[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ReEnrollStudentsComponent>,
    private lookupService: LookupService,
    private sharedService: SharedService,
    private userService: UserService,
    private studentService: StudentService,
    private yearService: YearService,
    private onlineRegistrationService: OnlineRegistrationService) { }

  ngOnInit() {
    this.currentUser = this.userService.currentUser;
    this.yearId = this.data.yearId;
    this.familyId = this.data.familyId;
    this.selectedYear = this.data.selectedYear;

    this.lookupService.getGradeLevelLookup(true, this.yearId).subscribe(result => {
      this.gradeLevels = result;
    });

    this.sharedService.getReEnrollStudentsList(this.yearId, this.familyId, 0).subscribe(students => {
      students.forEach(element => {
        element.EnrollmentGradeLevel = '';
      });
      this.students = students;
      this.angularMatDataStudents.data = this.students;
    });
  }

  modalInstanceCancelClick() {
    this.dialogRef.close('Cancel');
  }

  modalInstanceContinueClick() {
    this.validateStudents();
    if (this.errors.length == 0) {
      let studentIds = '';
      let gradeLevelIds = '';
      this.students.forEach(element => {
        if (element.Selected == true) {
          studentIds = studentIds == '' ? element.StudentId.toString() : (studentIds + ',' + element.StudentId.toString());
          gradeLevelIds = gradeLevelIds == '' ? element.EnrollmentGradeLevel.toString() : (gradeLevelIds + ',' + element.EnrollmentGradeLevel.toString());
        }
      });

      this.sharedService.markStudentsAsNew(this.yearId, this.familyId, studentIds, gradeLevelIds).subscribe(result => {
        this.studentService.getParentAssignedStudents(this.userService.userId, this.yearService.defaultYear.Id, this.userService.currentUser.UserType).subscribe((students: Student[]) => {
          this.studentService.selectedStudent = students.find(x => x.Id == this.studentService.selectedStudent.Id);
          this.studentService.updateStudents(students);
        });
        this.yearService.student360Year = this.selectedYear;
        this.onlineRegistrationService.ORYear = this.selectedYear;
        this.onlineRegistrationService.familyId = this.familyId;
        this.onlineRegistrationService.parentType = this.students[0].IsPrimaryParent == false ? 'Nonresident Parent' : '';
        this.dialogRef.close('Close');
      });
    }
  }

  selectAll() {
    if (this.allStudentsSelected) {
      this.angularMatDataStudents.data.forEach(student => {
        student.Selected = true;
      });
    }
    else {
      this.angularMatDataStudents.data.forEach(student => {
        student.Selected = false;
      });
    }
  }

  studentSelect() {
    this.allStudentsSelected = this.angularMatDataStudents.data.filter(x => x.Selected == true).length == this.angularMatDataStudents.data.length;
  }

  validateStudents() {
    this.errors = [];
    let element: ElementRef;
    if (this.students.filter(x => x.Selected == true).length == 0) {
      this.errors.push({
        fieldName: null,
        fieldRef: null,
        errorMsg: 'At least one student must be selected.'
      });
    }

    for (let i = 0; i < this.students.length; i++) {
      if (this.students[i].Selected == true && (this.students[i].EnrollmentGradeLevel == '0' || this.students[i].EnrollmentGradeLevel == '')) {
        element = new ElementRef(document.getElementById('selectedGradeLevel' + this.students[i].StudentId));
        // $('#selectTylerFormField' + this.students[i].StudentId).css('border', 'thin solid red');
        this.students[i].EnrollmentGradeLevel = '0';
        this.errors.push({
          fieldName: 'Grade',
          fieldRef: element,
          errorMsg: 'Required for selected students'
        });
      }

    }
  }

}
